import useSSR from './use-ssr';
export default useSSR;